(function () {
  function init(el) {
    if (!el || el.getAttribute('data-bt-rv-init') === '1') return;
    el.setAttribute('data-bt-rv-init', '1');
    var KEY = 'bt_recently_viewed';
    var MAX = 8;
    var current = el.dataset.current || '';
    var limit = parseInt(el.dataset.limit, 10) || 4;
    var root = (el.dataset.root || '/').replace(/\/$/, '');
    var list = [];

    try {
      list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) list = [];
    } catch (e) {
      list = [];
    }
    list = list.filter(function (h) {
      return typeof h === 'string' && h.length > 0 && h.length < 256;
    });

    if (current) {
      list = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, MAX);
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var toShow = list.filter(function (h) { return h !== current; }).slice(0, limit);
    if (!toShow.length) return;

    var money;
    try {
      money = new Intl.NumberFormat(el.dataset.locale || undefined, {
        style: 'currency',
        currency: el.dataset.currency || 'USD',
      });
    } catch (e) {
      money = { format: function (n) { return '$' + n.toFixed(2); } };
    }

    function imgUrl(src, width) {
      if (!src) return '';
      if (typeof src === 'object') src = src.src || src.url || '';
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function node(tag, cls, parent) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (parent) parent.appendChild(n);
      return n;
    }

    function card(p) {
      var li = node('li', 'grid__item');
      var wrap = node('div', 'card-wrapper product-card-wrapper underline-links-hover', li);
      var c = node('div', 'card card--standard card--media', wrap);
      c.style.setProperty('--ratio-percent', '100%');
      var inner = node('div', 'card__inner ratio', c);
      inner.style.setProperty('--ratio-percent', '100%');
      var feat = p.featured_image || (p.images && p.images[0]) || null;
      if (feat) {
        var media = node('div', 'card__media', inner);
        var m = node('div', 'media media--transparent media--hover-effect', media);
        m.style.paddingBottom = '100%';
        m.style.position = 'relative';
        var img = node('img', 'motion-reduce', m);
        img.src = imgUrl(feat, 533);
        img.srcset = imgUrl(feat, 360) + ' 360w, ' + imgUrl(feat, 533) + ' 533w, ' + imgUrl(feat, 720) + ' 720w';
        img.sizes = '(min-width: 990px) 25vw, 50vw';
        img.alt = p.title || '';
        img.loading = 'lazy';
        img.width = 533;
        img.height = 533;
        img.style.position = 'absolute';
        img.style.inset = '0';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
      }
      var content = node('div', 'card__content', c);
      var info = node('div', 'card__information', content);
      var h = node('h3', 'card__heading h5', info);
      var a = node('a', 'full-unstyled-link', h);
      a.href = root + '/products/' + encodeURIComponent(p.handle);
      a.textContent = p.title || '';
      var ci = node('div', 'card-information', info);
      var price = node('div', 'price', ci);
      var pc = node('div', 'price__container', price);
      var reg = node('div', 'price__regular', pc);
      var pi = node('span', 'price-item price-item--regular', reg);
      pi.textContent = money.format((p.price || 0) / 100);
      return li;
    }

    function persist(next) {
      list = next;
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var grid = el.querySelector('.product-grid');
    Promise.all(
      toShow.map(function (h) {
        return fetch(root + '/products/' + encodeURIComponent(h) + '.js', {
          headers: { Accept: 'application/json' },
        })
          .then(function (r) {
            if (!r.ok) return { handle: h, ok: false };
            return r.json().then(function (p) {
              p.handle = p.handle || h;
              return { handle: h, ok: true, product: p };
            });
          })
          .catch(function () {
            return { handle: h, ok: false };
          });
      })
    ).then(function (results) {
      var dead = [];
      var shown = 0;
      results.forEach(function (res) {
        if (!res || !res.ok) {
          if (res && res.handle) dead.push(res.handle);
          return;
        }
        var p = res.product;
        if (p && p.handle && p.title) {
          grid.appendChild(card(p));
          shown++;
        }
      });
      if (dead.length) {
        persist(
          list.filter(function (h) {
            return dead.indexOf(h) === -1;
          })
        );
      }
      if (shown > 0) el.hidden = false;
    });
  }

  function boot() {
    document.querySelectorAll('.bt-recently-viewed[data-bt-rv]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
